interface StripePaymentMethod {
    id: string
    card: {
        last4: string
    }
}

export function getMethodId(method: StripePaymentMethod) {
    return method?.id ?? ''
}

export function getLastFourDigitsOfMethodCard(method: StripePaymentMethod) {
    return method?.card?.last4 ?? ''
}

export function getMethodCard(method: StripePaymentMethod) {
    return method?.card ?? { last4: '' }
}